import { BlocksListener } from '../../game/blocks-listener';
import { BlocksDealer } from './blocks-dealer';
import { Secret } from 'game-logic';

export class RemoteDealer implements BlocksDealer {
  private readonly gameListener: BlocksListener;
  private cachedDisclosedSecrets: Secret[] = [];

  constructor(gameListener: BlocksListener) {
    this.gameListener = gameListener;
  }

  public async discloseSecrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<number[]> {
    // Try and match indexes with cached disclosed secrets first
    const existingDisclosedSecrets = this.matchDisclosedSecrets(
      indexes,
      this.cachedDisclosedSecrets,
    );
    if (existingDisclosedSecrets.length === indexes.length) {
      return existingDisclosedSecrets;
    }
    // Get secrets from the cloud
    return await this.secrets(indexes, gameHash, disclosedSecrets, existingDeal);
  }

  private async secrets(
    indexes: number[],
    gameHash: string,
    disclosedSecrets: number,
    existingDeal: boolean,
  ): Promise<number[]> {
    const response = await this.gameListener.discloseSecrets(
      indexes,
      gameHash,
      disclosedSecrets,
      existingDeal,
    );
    if (response === undefined) {
      return [];
    }
    this.cacheSecrets(response);

    return this.matchDisclosedSecrets(indexes, response);
  }

  private matchDisclosedSecrets(indexes: number[], disclosedSecrets: Secret[]) {
    const cachedSecrets: number[] = [];
    indexes.forEach((index) => {
      for (const secret of disclosedSecrets) {
        if (secret.index === index) {
          cachedSecrets.push(secret.value);
          break;
        }
      }
    });
    return cachedSecrets;
  }

  private cacheSecrets(secrets: Secret[]) {
    secrets.forEach((secret) => {
      if (!this.cachedDisclosedSecrets.some((existing) => existing.index === secret.index)) {
        this.cachedDisclosedSecrets.push(secret);
      }
    });
  }
}
